import { shortcutLabel } from "./markdown/document-session";

export type ShortcutHint = {
  readonly keys: string;
  readonly action: string;
};

export type ShortcutGroup = {
  readonly title: string;
  readonly items: readonly ShortcutHint[];
};

export function keyboardShortcutGroups(): readonly ShortcutGroup[] {
  return [
    {
      title: "App",
      items: [{ keys: shortcutLabel("/"), action: "Show this list" }],
    },
    {
      title: "Document",
      items: [
        { keys: shortcutLabel("e"), action: "Edit" },
        { keys: shortcutLabel("s"), action: "Save" },
        { keys: shortcutLabel("k"), action: "Link selection" },
        { keys: shortcutLabel("b"), action: "Bold in Source" },
        { keys: shortcutLabel("i"), action: "Italic in Source" },
        { keys: shortcutLabel("f"), action: "Find in Source" },
        { keys: "/", action: "Slash commands in Formatted" },
      ],
    },
    {
      title: "Folder tree",
      items: [
        { keys: "↑ ↓", action: "Move" },
        { keys: "← →", action: "Collapse or expand" },
        { keys: "Enter", action: "Open file" },
        { keys: "Home End", action: "First or last" },
      ],
    },
    {
      title: "Document pane",
      items: [
        { keys: "↑ ↓", action: "Scroll" },
        { keys: "Page Up / Down", action: "Jump a page" },
        { keys: "Home End", action: "Top or bottom" },
      ],
    },
  ];
}

export function isShortcutHelpEvent(event: KeyboardEvent): boolean {
  if (event.isComposing || event.altKey || event.shiftKey) {
    return false;
  }
  return (
    (event.metaKey || event.ctrlKey) && (event.key === "/" || event.key === "?")
  );
}
